import styled from 'styled-components'

import { Button as But } from '../../../../components/v2Components'

export const Button = styled(But)`
  width: 100%;
  max-width: 280px;
`
